import * as Types from '../constants/Types';

export const getListPages = (filters) => ({ type: Types.PAGE_LIST_ACTION, filters });
export const setListPages = (data) => ({ type: Types.PAGE_LIST_SUCCESS, pages: data.pages, pageIndex: data.pageIndex, pageSize: data.pageSize, totalCount: data.totalCount });

export const getPageDetail = (id) => ({ type: Types.PAGE_DETAIL_ACTION, id });
export const setPageDetail = (page) => ({ type: Types.PAGE_DETAIL_SUCCESS, page });
export const updatePageDetail = (page) => ({ type: Types.PAGE_DETAIL_UPDATE_ACTION, page });
export const createPageDetail = (page) => ({ type: Types.PAGE_DETAIL_CREATE_ACTION, page });
export const deletePageDetail = (page, filters) => ({ type: Types.PAGE_DETAIL_DELETE_ACTION, page, filters });

export const createPageTranslate = (page) => ({type: Types.PAGE_CREATE_TRANSLATE_ACTION, page});
export const updatePageTranslate = (page) => ({type: Types.PAGE_UPDATE_TRANSLATE_ACTION, page});
export const deletePageTranslate = (page, refreshParams) => ({type: Types.PAGE_DELETE_TRANSLATE_ACTION, page, refreshParams});

